const BadgeButton = ({
     id,
     className,
     text = '',
     onClick = () => null,
}) => {
    return (
        <div
            id={id}
            className={`badge-button ${className ? className : ''}`}
            onClick={onClick}
        >
            {text}
        </div>
    );
};

export default BadgeButton;
